import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import View from "../Components/Others/View";
import MyOthers from "../Components/Others/MyOthers";

function MyOthersRequest() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  const [myOthers, setMyOthers] = useState(true);

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <MyOthers
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setCurrentorder={setCurrentorder}
          />
        );
      case "view":
        return (
          <View
            comp={comp}
            rowData={rowData}
            onChange={handleChange}
            myOthers={myOthers}
          />
        );
    }
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>My Others Request</h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default MyOthersRequest;
